import { IProductTexture, ProductTexture } from "../../entities-generated/common/product-texture";
import { IStormDoorColorOption } from "../../entities-generated/common/storm-door-color-option";

export class ProductTextureEditingModel extends ProductTexture
{
  constructor(pt: IProductTexture, public colorFamilies: IStormDoorColorOption[])
  {
    super();
    this.id = pt.id;
    this.name = pt.name;
    this.swatchUrl = pt.swatchUrl;
    this.productImageUrls = pt.productImageUrls;
    this.colorFamily = pt.colorFamily;
  }
}